import ks from "../kalmstromShared4";

declare global { interface Window { JSZip: any; } }
import JSZip from "..//Zip/jszip.min.js";
window.JSZip = JSZip;

export class kZip {
    public static Dummy(): void {
        if (ks.kErrorMode === true) { return; }
        try {
            void window.JSZip;
        } catch (e) { ks.kGlobalErrorHandler(e, "kZip.Dummy"); }
    }

    // Lifecycle
    public static FromBlob(source: Blob | ArrayBuffer | Uint8Array, cb: (zip?: any) => void): void {
        if (ks.kErrorMode === true) { return; }
        try {
            const p = window.JSZip.loadAsync(source);
            p.then(kZip.FromBlob_OnSuccess(cb));
            p.catch(kZip.LogError("kZip.FromBlob"));
        } catch (e) { ks.kGlobalErrorHandler(e, "kZip.FromBlob"); }
    }

    public static FromBase64(Base64Data: string, cb: (zip?: any) => void): void {
        if (ks.kErrorMode === true) { return; }
        try {
            const Binary: string = atob(Base64Data);
            const Bytes: Uint8Array = new Uint8Array(Binary.length);
            for (let I: number = 0; I < Binary.length; I++) {
                Bytes[I] = Binary.charCodeAt(I);
            }
            const p = window.JSZip.loadAsync(Bytes);
            p.then(kZip.FromBlob_OnSuccess(cb));
            p.catch(kZip.LogError("kZip.FromBase64"));
        } catch (e) { ks.kGlobalErrorHandler(e, "kZip.FromBase64"); }
    }

    public static CleanBase64(Input: string): string {
        if (ks.kErrorMode === true) { return ""; }
        try {
            let EndIdx: number = Input.length;
            while (EndIdx > 0) {
                const CharCode: number = Input.charCodeAt(EndIdx - 1);
                const IsBase64Char: boolean = (CharCode >= 65 && CharCode <= 90)
                    || (CharCode >= 97 && CharCode <= 122)
                    || (CharCode >= 48 && CharCode <= 57)
                    || CharCode === 43 || CharCode === 47 || CharCode === 61;
                if (IsBase64Char) { break; }
                EndIdx--;
            }
            if (EndIdx === Input.length) { return Input; }
            return Input.substring(0, EndIdx);
        } catch (e) {
            ks.kGlobalErrorHandler(e, "kZip.CleanBase64");
            return Input;
        }
    }

    public static ToBlob(zip: any, cb: (blob?: Blob) => void): void {
        if (ks.kErrorMode === true) { return; }
        try {
            const p = zip.generateAsync({ 
                type: "blob",
                compression: "DEFLATE",
                compressionOptions: {
                    level: 9
                }
            });
            p.then(kZip.ToBlob_OnSuccess(cb));
            p.catch(kZip.LogError("kZip.ToBlob"));
        } catch (e) { ks.kGlobalErrorHandler(e, "kZip.ToBlob"); }
    }
    
    // Queries
    public static Exists(zip: any, path: string): boolean {
        if (ks.kErrorMode === true) { return false; }
        try {
            return !!zip.file(path);
        } catch (e) { ks.kGlobalErrorHandler(e, "kZip.Exists"); return false; }
    }

    public static ListPaths(zip: any, prefix?: string): string[] {
        if (ks.kErrorMode === true) { return []; }
        try {
            const out: string[] = [];
            const fn = kZip.ListPaths_Collector(prefix, out);
            zip.forEach(fn);
            return out.sort();
        } catch (e) { ks.kGlobalErrorHandler(e, "kZip.ListPaths"); return []; }
    }

    // Reads
    public static ReadText(zip: any, path: string, cb: (text?: string) => void): void {
        if (ks.kErrorMode === true) { return; }
        try {
            const f = zip.file(path);
            if (!f) { ks.kGlobalErrorHandler(new Error("Missing file: " + path), "kZip.ReadText"); return; }
            const p = f.async("text");
            p.then(kZip.ReadText_OnSuccess(cb));
        } catch (e) { ks.kGlobalErrorHandler(e, "kZip.ReadText"); }
    }

    public static ReadArrayBuffer(zip: any, path: string, cb: (buffer?: ArrayBuffer) => void): void {
        if (ks.kErrorMode === true) { return; }
        try {
            const f = zip.file(path);
            if (!f) { ks.kGlobalErrorHandler(new Error("Missing file: " + path), "kZip.ReadArrayBuffer"); return; }
            const p = f.async("arraybuffer");
            p.then(kZip.ReadArrayBuffer_OnSuccess(cb));
            p.catch(kZip.LogError("kZip.ReadArrayBuffer"));
        } catch (e) { ks.kGlobalErrorHandler(e, "kZip.ReadArrayBuffer"); }
    }

    // Writes
    public static WriteText(zip: any, path: string, text: string, Callback:any): void {
        if (ks.kErrorMode === true) { return; }
        try {
            zip.file(path, text || "");
            ks.DoCallBack(Callback);
        } catch (e) { ks.kGlobalErrorHandler(e, "kZip.WriteText"); }
    }

    public static WriteArrayBuffer(zip: any, path: string, buffer: ArrayBuffer, Callback:any): void {
        if (ks.kErrorMode === true) { return; }
        try {
            zip.file(path, buffer);
            ks.DoCallBack(Callback);
        } catch (e) { ks.kGlobalErrorHandler(e, "kZip.WriteArrayBuffer"); }
    }

    public static EnsureEmptyFile(zip: any, path: string, cb?: () => void): void {
        if (ks.kErrorMode === true) { return; }
        try {
            if (!zip.file(path)) { 
                zip.file(path, ""); 
            }
            if (cb) { cb(); }
        } catch (e) { ks.kGlobalErrorHandler(e, "kZip.EnsureEmptyFile"); }
    }

    // Mutations
    public static Remove(zip: any, path: string, cb?: () => void): void {
        if (ks.kErrorMode === true) { return; }
        try {
            zip.remove(path);
            if (cb) { cb(); }
        } catch (e) { ks.kGlobalErrorHandler(e, "kZip.Remove"); }
    }

    public static Move(zip: any, fromPath: string, toPath: string, cb: () => void): void {
        if (ks.kErrorMode === true) { return; }
        try {
            const f = zip.file(fromPath);
            if (!f) { ks.kGlobalErrorHandler(new Error("Missing file: " + fromPath), "kZip.Move"); return; }
            const isText = kZip.IsTextLike(fromPath);
            const p = f.async(isText ? "text" : "arraybuffer");
            p.then(kZip.Move_OnLoaded(zip, fromPath, toPath, cb));
            p.catch(kZip.LogError("kZip.Move"));
        } catch (e) { ks.kGlobalErrorHandler(e, "kZip.Move"); }
    }

    public static EnsureFolder(zip: any, folderPath: string, cb?: () => void): void {
        if (ks.kErrorMode === true) { return; }

        try {
            zip.folder(folderPath);
            if (cb) { cb(); }
        } catch (e) { ks.kGlobalErrorHandler(e, "kZip.EnsureFolder"); }
    }

    // Handlers (named, success only)
    private static FromBlob_OnSuccess(cb: (zip?: any) => void) {
        return function(zip: any) { cb(zip); };
    }

    private static ToBlob_OnSuccess(cb: (blob?: Blob) => void) {
        return function(b: Blob) { cb(b); };
    }

    private static ReadText_OnSuccess(cb: (text?: string) => void) {
        return function(t: string) { cb(t); };
    }

    private static ReadArrayBuffer_OnSuccess(cb: (buffer?: ArrayBuffer) => void) {
        return function(b: ArrayBuffer) { cb(b); };
    }

    private static Move_OnLoaded(zip: any, fromPath: string, toPath: string, cb: () => void) {
        return function(data: any) {
            try {
                zip.file(toPath, data);
                zip.remove(fromPath);
                cb();
            } catch (e) { ks.kGlobalErrorHandler(e, "kZip.Move.inner"); }
        };
    }

    // Helpers
    private static ListPaths_Collector(prefix: string | undefined, out: string[]) {
        return function(relPath: string): void {
            if (!prefix || relPath.startsWith(prefix)) { out.push(relPath); }
        };
    }

    private static IsTextLike(path: string): boolean {
        return /\.(xml|txt|json|csv|rels)$/i.test(path);
    }

    private static LogError(tag: string) {
        return function(err: any): void { ks.kGlobalErrorHandler(err, tag); };
    }
}
